import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const AutoBrand: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { autoBrands } = useDictionaries(['autoBrands']);

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={autoBrands}
    />
  );
};
